export const SESSION_STATUS = Object.freeze({
    MISSING: 'missing',
    MALFORMED: 'malformed',
    EXPIRED: 'expired',
    VALID: 'valid'
});

export const AUTH_STORAGE_KEYS = Object.freeze([
    'token',
    'expiryTimestamp',
    'units',
    'activeUnit',
    'signedEula',
    'isFirstLogin',
    'user'
]);

export const clearOwnedAuthStorage = (sessionStorage, localStorage) => {
    AUTH_STORAGE_KEYS.forEach((key) => sessionStorage?.removeItem(key));
    localStorage?.removeItem('units');
    localStorage?.removeItem('activeUnit');
};

export const loadStoredSession = async (storage, now = Date.now()) => {
    const [token, expiryTimestamp, activeUnit] = await Promise.all([
        storage.get('token'),
        storage.get('expiryTimestamp'),
        storage.get('activeUnit')
    ]);

    if (token === null || token === undefined || token === '') {
        return { status: SESSION_STATUS.MISSING, token: null, activeUnit: null };
    }

    if (typeof token !== 'string') {
        return { status: SESSION_STATUS.MALFORMED, token: null, activeUnit: null };
    }

    if (expiryTimestamp !== null && expiryTimestamp !== undefined) {
        const normalizedExpiry = Number(expiryTimestamp);
        if (!Number.isFinite(normalizedExpiry)) {
            return { status: SESSION_STATUS.MALFORMED, token: null, activeUnit: null };
        }
        if (normalizedExpiry <= now) {
            return { status: SESSION_STATUS.EXPIRED, token, activeUnit };
        }
    }

    return { status: SESSION_STATUS.VALID, token, activeUnit };
};

export const resolveExpiryTimestamp = (expiry, now = Date.now()) => {
    const numericExpiry = Number(expiry);
    if (!Number.isFinite(numericExpiry) || numericExpiry <= 0) return now;

    const nowInSeconds = Math.floor(now / 1000);
    return numericExpiry > nowInSeconds
        ? numericExpiry * 1000
        : now + numericExpiry * 1000;
};
